<template>

    <Transition name="modal-fade">
        <div v-if="isdisplay" class="cf-overlay" @click.self="close">
            <Transition name="modal-slide">
                <div v-if="isdisplay" class="cf-dialog cf-dialog--xl">

                    <!-- Header -->
                    <div class="cf-modal-head cf-dialog-head">
                        <div class="cf-modal-head__main">
                            <span class="cf-modal-head__icon"><i class="ri-file-list-3-line"></i></span>
                            <div>
                                <h4 class="cf-dialog-title">{{ Items.article }}</h4>
                                <p class="cf-modal-head__sub">Fiche technique : composition pour 1 {{ Items.unite }} vendu(e)</p>
                            </div>
                        </div>
                        <button @click="close" type="button" class="cf-dialog-close" aria-label="Fermer"><i class="ri-close-line"></i></button>
                    </div>

                    <!-- Body -->
                    <div class="cf-dialog-body">

                        <!-- Indicateurs -->
                        <div class="ft-kpis">
                            <div class="ft-kpi">
                                <span class="ft-kpi__label">Coût matière</span>
                                <b class="ft-kpi__value">{{ formatMoney(coutTotal) }}</b>
                            </div>
                            <div class="ft-kpi">
                                <span class="ft-kpi__label">Prix de vente</span>
                                <b class="ft-kpi__value">{{ prixVente > 0 ? formatMoney(prixVente) : '-' }}</b>
                            </div>
                            <div class="ft-kpi">
                                <span class="ft-kpi__label">Part du coût matière</span>
                                <b class="ft-kpi__value" :class="partClass">{{ prixVente > 0 ? partCout + ' %' : '-' }}</b>
                            </div>
                            <div class="ft-kpi">
                                <span class="ft-kpi__label">Marge par vente</span>
                                <b class="ft-kpi__value">{{ prixVente > 0 ? formatMoney(marge) : '-' }}</b>
                            </div>
                        </div>

                        <p v-if="prixVente <= 0" class="ft-note ft-note--warn">
                            <i class="ri-alert-line"></i> Aucun prix de vente défini pour cet article dans cet entrepôt : la marge ne peut pas être calculée.
                        </p>
                        <p v-if="nbSansPrix > 0" class="ft-note ft-note--warn">
                            <i class="ri-alert-line"></i> {{ nbSansPrix }} matière(s) sans prix d'achat : le coût matière affiché est sous-estimé.
                        </p>
                        <p v-if="nbIgnorees > 0" class="ft-note ft-note--warn">
                            <i class="ri-alert-line"></i> {{ nbIgnorees }} ingrédient(s) ne feront rien sortir du stock : ils ne sont pas suivis en stock et n'ont pas de fiche technique.
                        </p>

                        <!-- Tableau de composition -->
                        <div class="table-scroll-wrap ft-scroll">
                            <table class="ft-table">
                                <thead>
                                <tr>
                                    <th class="th" style="width:44px">N°</th>
                                    <th class="th">Matière première</th>
                                    <th class="th">Unité</th>
                                    <th class="th th--right" style="width:130px">Portion</th>
                                    <th class="th th--right">Prix d'achat</th>
                                    <th class="th th--right">Coût</th>
                                    <th class="th th--center" style="width:92px" title="Le client peut demander le plat sans cet ingrédient">Peut être retiré</th>
                                    <th class="th th--center" style="width:92px" title="Le client peut demander une double portion de cet ingrédient">Peut être doublé</th>
                                    <th class="th th--center" style="width:60px"></th>
                                </tr>
                                </thead>
                                <tbody>
                                <template v-if="lignes.length">
                                    <tr class="table-row" v-for="(ligne,index) in lignes" :key="ligne.pid">
                                        <td class="td">{{ index+1 }}</td>
                                        <td class="td">
                                            <span class="cf-strong">{{ ligne.libelle }}</span>
                                            <span v-if="ligne.isnew" class="cf-st cf-st--info ft-tag">Nouvelle</span>
                                            <span v-else-if="estModifiee(ligne)" class="cf-st cf-st--warn ft-tag">Modifiée</span>
                                            <span v-if="natureLigne(ligne) === 'sousrecette'" class="cf-st cf-st--info ft-tag" title="Cet ingrédient a sa propre fiche technique : ce sont ses matières qui sortent du stock">Sous-recette</span>
                                            <span v-else-if="natureLigne(ligne) === 'ignoree'" class="cf-st cf-st--ko ft-tag" title="Ni suivi en stock, ni sous-recette : rien ne sortira du stock pour cet ingrédient">Rien ne sort du stock</span>
                                            <span v-if="natureLigne(ligne) !== 'ignoree' && prixUnitaire(ligne) <= 0" class="cf-st cf-st--ko ft-tag">Sans prix d'achat</span>
                                            <div v-if="natureLigne(ligne) === 'sousrecette'" class="ft-sous">
                                                Pour {{ formatQte(ligne.qte) }} {{ ligne.unite }} :
                                                <span v-for="(feuille,i) in feuillesLigne(ligne)" :key="feuille.pid">{{ i ? ', ' : '' }}{{ formatQte(feuille.qte * (parseFloat(ligne.qte) || 0)) }} {{ feuille.unite }} {{ feuille.libelle }}</span>
                                            </div>
                                        </td>
                                        <td class="td">{{ ligne.unite }}</td>
                                        <td class="td td--right">
                                            <input v-model.number="ligne.qte" type="number" min="0" step="any" class="ft-qte" :class="{ 'ft-qte--err': !(ligne.qte > 0) }">
                                        </td>
                                        <td class="td td--right">{{ prixUnitaire(ligne) > 0 ? formatMoney(prixUnitaire(ligne)) : '-' }}</td>
                                        <td class="td td--right cf-strong">{{ formatMoney(coutLigne(ligne)) }}</td>
                                        <td class="td td--center"><input v-model="ligne.retirable" type="checkbox" class="ft-check" aria-label="Peut être retiré"></td>
                                        <td class="td td--center"><input v-model="ligne.doublable" type="checkbox" class="ft-check" aria-label="Peut être doublé"></td>
                                        <td class="td td--center">
                                            <button @click="retirer(ligne)" type="button" class="ft-del" title="Retirer cette matière" aria-label="Retirer"><i class="ri-delete-bin-line"></i></button>
                                        </td>
                                    </tr>
                                </template>
                                <template v-else>
                                    <tr>
                                        <td colspan="9" class="td">
                                            <div class="empty-state">
                                                <div class="empty-state__icon"><i class="ri-inbox-line"></i></div>
                                                <p class="empty-state__title">Aucune matière première dans cette fiche.</p>
                                                <p class="empty-state__sub">Ajoutez les matières consommées pour préparer cet article.</p>
                                            </div>
                                        </td>
                                    </tr>
                                </template>
                                </tbody>
                                <tfoot v-if="lignes.length">
                                <tr>
                                    <td class="td ft-total" colspan="5">Coût matière total</td>
                                    <td class="td td--right ft-total">{{ formatMoney(coutTotal) }}</td>
                                    <td class="td" colspan="3"></td>
                                </tr>
                                </tfoot>
                            </table>
                        </div>

                        <!-- Actions de composition -->
                        <div class="ft-actions">
                            <button @click="ouvrirListeMatieres" type="button" class="ti-btn ti-btn-primary-full">
                                <i class="ri-add-line"></i> Ajouter une matière
                            </button>
                            <div class="ft-copy">
                                <select v-model="platsource" class="cf-inp cf-select">
                                    <option :value="null">Copier depuis un autre article…</option>
                                    <option v-for="plat in autresPlats" :key="plat.pid" :value="plat">{{ plat.libelle }}</option>
                                </select>
                                <button @click="copierDepuis" :disabled="platsource===null" type="button" class="ti-btn ti-btn-light">
                                    <i class="ri-file-copy-line"></i> Copier
                                </button>
                            </div>
                        </div>

                        <p class="ft-note">
                            « Peut être retiré » et « Peut être doublé » : choix proposés à la caisse pour ce plat. Sans case cochée, l'ingrédient n'est pas modifiable.
                            Le double doit aussi être autorisé dans Paramètres, Autorisations système.
                        </p>

                        <p v-if="supprimees.length" class="ft-note">
                            {{ supprimees.length }} matière(s) retirée(s) : la suppression sera appliquée à l'enregistrement.
                        </p>

                    </div>

                    <!-- Footer -->
                    <div class="cf-dialog-foot">
                        <span v-if="aDesChangements" class="ft-foot-info"><i class="ri-edit-circle-line"></i> Modifications non enregistrées</span>
                        <button @click="close" type="button" class="ti-btn ti-btn-secondary-full">Fermer</button>
                        <button @click="enregistrer" :disabled="saving || !aDesChangements" type="button" class="ti-btn ti-btn-success-full">
                            <i class="ri-check-line"></i> {{ saving ? 'Enregistrement…' : 'Enregistrer' }}
                        </button>
                    </div>

                </div>
            </Transition>
        </div>
    </Transition>

    <modallistedesarticles @elementSelectionnearticle="handleElementSelectedarticle" ref="modallistedesarticles"></modallistedesarticles>

</template>

<script>
    import {mapGetters} from "vuex";
    import {currencyFormatDE, randomString} from "@/allfunction";
    import * as JwtService from "@/common/jwt.service";
    import modallistedesarticles from "@/components/views/pages/stock/fichetechnique/modal_listedesmatierepremiere";
    const axios =require('axios');

    export default {
        /* eslint-disable */
        name: "modalformv2",

        components: {
            modallistedesarticles
        },

        computed:{
            ...mapGetters(['listedesarticles']),

            // pid article -> ligne de la liste des articles
            articleMap(){
                let map={};
                for (let article of this.listedesarticles){
                    map[article.pid]=article;
                }
                return map;
            },

            prixVente(){
                let article=this.articleMap[this.Items.pidar];
                if (!article) return 0;
                let tarifmag=this.tarifMagasin(article);
                let pu=tarifmag!==null?parseFloat(tarifmag.pu):0;
                if (!(pu>0)) pu=parseFloat(article.pu);
                return pu>0?pu:0;
            },

            coutTotal(){
                let total=0;
                for (let ligne of this.lignes){
                    total+=this.coutLigne(ligne);
                }
                return total;
            },

            marge(){
                return this.prixVente-this.coutTotal;
            },

            partCout(){
                if (!(this.prixVente>0)) return 0;
                return Math.round((this.coutTotal/this.prixVente)*1000)/10;
            },

            partClass(){
                if (!(this.prixVente>0)) return '';
                if (this.partCout>50) return 'ft-kpi__value--ko';
                if (this.partCout>35) return 'ft-kpi__value--warn';
                return 'ft-kpi__value--ok';
            },

            nbSansPrix(){
                let t=this;
                return this.lignes.filter(function (ligne) {
                    return t.natureLigne(ligne)!=='ignoree' && !(t.prixUnitaire(ligne)>0)
                }).length;
            },

            // ingrédients ni suivis en stock ni sous-recette : rien ne sort du stock pour eux
            nbIgnorees(){
                let t=this;
                return this.lignes.filter(function (ligne) {
                    return t.natureLigne(ligne)==='ignoree'
                }).length;
            },

            aDesChangements(){
                if (this.supprimees.length>0) return true;
                let t=this;
                return this.lignes.some(function (ligne) {
                    return ligne.isnew || t.estModifiee(ligne)
                }) || this.optionsModifiees;
            },

            // options « peut être retiré / doublé » différentes de celles enregistrées
            optionsModifiees(){
                return this.lignes.some(function (ligne) {
                    return !!ligne.retirable!==!!ligne.retirableinit || !!ligne.doublable!==!!ligne.doublableinit
                });
            },

            autresPlats(){
                let t=this;
                return this.listedesarticles.filter(function (article) {
                    return parseFloat(article.fichetechnique)===1 && article.pid!==t.Items.pidar
                });
            },
        },

        data() {
            return {
                isdisplay:false,
                saving:false,
                Items: {},
                lignes:[],
                supprimees:[],
                platsource:null,
                // sous-recettes : pid d'ingrédient -> { nature, feuilles:[{pid,libelle,unite,qte}] }
                composition:{},
            };
        },

        methods: {

            formatMoney(value){
                return currencyFormatDE(value)
            },

            headers(){
                return {
                    headers: {
                        'X-Requested-With': 'XMLHttpRequest',
                        'Accept': 'application/json',
                        'Content-Type': 'application/json',
                        'Authorization': 'Bearer ' + JwtService.getToken(),
                        'csrftoken': this.$store.state.appsociete
                    } ,withCredentials: true // Permet l'envoi de cookies et autres informations d'authentification
                }
            },

            // tarif de l'article dans l'entrepôt de la fiche (pu / pa par magasin)
            tarifMagasin(article){
                if (!Array.isArray(article.jsonarticles)) return null;
                let pidmag=(this.Items.pidmag||'').toString().toLowerCase();
                let res=article.jsonarticles.find(function (item) {
                    return item.mg && item.mg.pid && item.mg.pid.toString().toLowerCase()===pidmag
                });
                return res||null;
            },

            prixAchat(pid){
                let article=this.articleMap[pid];
                if (!article) return 0;
                let pa=parseFloat(article.pa);
                if (!(pa>0)){
                    let tarifmag=this.tarifMagasin(article);
                    pa=tarifmag!==null?parseFloat(tarifmag.pa):0;
                }
                return pa>0?pa:0;
            },

            /* Sous-recettes : un ingrédient qui a sa propre fiche est remplacé, au
               déstockage, par les matières de cette fiche. Tant que la réponse du
               serveur n'est pas là, la ligne est traitée comme une matière simple. */
            natureLigne(ligne){
                let c=this.composition[ligne.pid];
                return c?c.nature:'matiere';
            },

            feuillesLigne(ligne){
                let c=this.composition[ligne.pid];
                return (c && c.nature==='sousrecette')?c.feuilles:[];
            },

            // coût d'une unité de l'ingrédient : son prix d'achat, ou le coût des matières de sa fiche
            prixUnitaire(ligne){
                if (this.natureLigne(ligne)!=='sousrecette') return this.prixAchat(ligne.pid);
                let t=this,total=0;
                this.feuillesLigne(ligne).forEach(function (feuille) {
                    total+=parseFloat(feuille.qte)*t.prixAchat(feuille.pid);
                });
                return total;
            },

            formatQte(value){
                let n=parseFloat(value);
                if (!isFinite(n)) return '0';
                return (Math.round(n*1000)/1000).toString().replace('.',',');
            },

            coutLigne(ligne){
                let qte=parseFloat(ligne.qte);
                if (!(qte>0)) return 0;
                return qte*this.prixUnitaire(ligne);
            },

            // nature des ingrédients de la fiche (lignes enregistrées ou non)
            async loadComposition(){

                let pids=this.lignes.map(function (ligne) { return ligne.pid });
                if (pids.length===0) return;

                let url=process.env.VUE_APP_API_URL+'/egl745874pstock771714dfe/fichetechnique/composition/'+this.$store.state.appsociete+'/'+randomString();

                try {
                    let res=await axios.post(url,{pidar:this.Items.pidar,pids:pids},this.headers());
                    if (res.data.success) this.composition=res.data.m||{};
                }catch (error) {
                    /* indisponible : la fiche reste utilisable, sans le détail des sous-recettes */
                }

            },

            estModifiee(ligne){
                return !ligne.isnew && parseFloat(ligne.qte)!==parseFloat(ligne.qteinit)
            },

            show(titlemodal,Items){

                this.Items=Items
                this.lignes=[];
                this.supprimees=[];
                this.platsource=null;
                this.composition={};
                this.saving=false;
                this.$store.dispatch('loadlistedesarticles')
                this.loadfichetechnique()

                this.isdisplay=true;

            },

            close(){

                if (this.aDesChangements){
                    if (!window.confirm("Des modifications ne sont pas enregistrées. Fermer quand même ?")) return;
                }

                this.lignes=[];
                this.supprimees=[];
                this.isdisplay=false;

                this.$emit('closed');

            },

            ouvrirListeMatieres(){
                this.$refs.modallistedesarticles.show("Liste des Articles (Matière première)",'vente',[],this.Items.pidmag);
            },

            handleElementSelectedarticle(elementSelectionne) {

                let value=elementSelectionne.value;

                if (value===null || value.pid==="") return;

                if (this.ajouterLigne(value,0)) this.loadComposition()

            },

            ajouterLigne(matiere,qte){

                if (matiere.pid===this.Items.pidar){
                    toastr['error']( "Un article ne peut pas être sa propre matière première.","<b></b>");
                    return false;
                }

                let existe=this.lignes.some(function (ligne) {
                    return ligne.pid===matiere.pid
                });

                if (existe){
                    toastr['error']( matiere.libelle+' existe déjà dans la fiche.',"<b></b>");
                    return false;
                }

                // une matière retirée puis rajoutée redevient une ligne existante
                let index=this.supprimees.findIndex(function (ligne) {
                    return ligne.pid===matiere.pid
                });

                if (index>=0){
                    let ancienne=this.supprimees.splice(index,1)[0];
                    if (qte>0) ancienne.qte=qte;
                    this.lignes.push(ancienne);
                    return true;
                }

                this.lignes.push({
                    pid:matiere.pid,
                    libelle:matiere.libelle,
                    unite:matiere.unite,
                    qte:qte,
                    qteinit:0,
                    isnew:true,
                    retirable:false,
                    doublable:false,
                    retirableinit:false,
                    doublableinit:false,
                });

                return true;

            },

            retirer(ligne){

                let index=this.lignes.indexOf(ligne);
                if (index<0) return;

                this.lignes.splice(index,1);

                if (!ligne.isnew){
                    this.supprimees.push(ligne);
                }

            },

            async copierDepuis(){

                if (this.platsource===null) return;

                let t=this,nbajout=0;
                let url=process.env.VUE_APP_API_URL+'/egl745874pstock771714dfe/fichetechnique/getall/'+this.platsource.pid+'/'+this.$store.state.appsociete+'/'+randomString();

                try {

                    let res=await axios.get(url,this.headers());

                    if (res.data.success){

                        for (let line of res.data.m){

                            let dejala=t.lignes.some(function (ligne) {
                                return ligne.pid===line.matiere.pid
                            });

                            if (dejala || line.matiere.pid===t.Items.pidar) continue;

                            if (t.ajouterLigne(line.matiere,parseFloat(line.qte))) nbajout++;

                        }

                    }

                    if (nbajout>0){
                        t.loadComposition();
                        toastr['success']( nbajout+" matière(s) copiée(s). Vérifiez les portions puis enregistrez.","<b></b>");
                    }else{
                        toastr['error']( "Aucune matière à copier depuis cet article.","<b></b>");
                    }

                }catch (error) {
                    toastr['error']( "Une erreur est subvenue. <br/> veuillez contacter votre administrateur.","<b></b>");
                }

                this.platsource=null;

            },

            payloadLigne(ligne){
                return {
                    article:{
                        pid:this.Items.pidar,
                        libelle:this.Items.article,
                        unite:this.Items.unite,
                    },
                    matiere:{
                        pid:ligne.pid,
                        libelle:ligne.libelle,
                        unite:ligne.unite,
                    },
                    pidar:this.Items.pidar,
                    pidmag:this.Items.pidmag,
                    pidfich:ligne.pid,
                    portion:parseFloat(ligne.qte),
                    etatline:1,
                }
            },

            async enregistrer(){

                let invalide=this.lignes.find(function (ligne) {
                    return !(parseFloat(ligne.qte)>0)
                });

                if (invalide){
                    toastr['error']( 'Veuillez saisir la portion de '+invalide.libelle,"<b></b>");
                    return;
                }

                let t=this,erreurs=[];
                let base=process.env.VUE_APP_API_URL+'/egl745874pstock771714dfe/fichetechnique/';

                this.saving=true;

                // 1. suppressions
                for (let ligne of this.supprimees.slice()){

                    let payload=this.payloadLigne(ligne);
                    payload.portion=parseFloat(ligne.qteinit)>0?parseFloat(ligne.qteinit):1;

                    try {
                        let res=await axios.post(base+'deleteline/'+this.$store.state.appsociete+'/'+randomString(),payload,this.headers());
                        if (!res.data.success) erreurs.push(ligne.libelle+" : "+res.data.message);
                    }catch (error) {
                        erreurs.push(ligne.libelle+" : suppression impossible");
                    }

                }

                // 2. ajouts et modifications
                for (let ligne of this.lignes){

                    if (!ligne.isnew && !this.estModifiee(ligne)) continue;

                    try {
                        let res=await axios.post(base+'add/'+this.$store.state.appsociete+'/'+randomString(),this.payloadLigne(ligne),this.headers());
                        if (!res.data.success){
                            let message=res.data.message;
                            if (Array.isArray(res.data.datamessage) && res.data.datamessage.length>0) message=res.data.datamessage.join(" , ");
                            erreurs.push(ligne.libelle+" : "+message);
                        }
                    }catch (error) {
                        erreurs.push(ligne.libelle+" : enregistrement impossible");
                    }

                }

                // 3. options des ingrédients (peut être retiré / doublé) : route dédiée, remplace les précédentes
                if (this.optionsModifiees || this.supprimees.length>0){

                    try {
                        let res=await axios.post(base+'ingredients/options/enregistrer/'+this.$store.state.appsociete+'/'+randomString(),{
                            pidar:this.Items.pidar,
                            lignes:this.lignes.map(function (ligne) {
                                return {pidfich:ligne.pid,retirable:!!ligne.retirable,doublable:!!ligne.doublable}
                            }),
                        },this.headers());
                        if (!res.data.success) erreurs.push("Ingrédients modifiables : "+res.data.message);
                    }catch (error) {
                        erreurs.push("Ingrédients modifiables : enregistrement impossible");
                    }

                }

                this.saving=false;

                if (erreurs.length>0){
                    toastr['error']( erreurs.join("<br/>"),"<b></b>");
                }else{
                    toastr['success']( "Fiche technique enregistrée.","<b></b>");
                }

                await this.loadfichetechnique()

            },

            // options « peut être retiré / doublé » de la fiche (aucune = ingrédients non modifiables)
            async loadOptions(){

                let url=process.env.VUE_APP_API_URL+'/egl745874pstock771714dfe/fichetechnique/ingredients/options/lire/'+this.$store.state.appsociete+'/'+randomString();

                try {

                    let res=await axios.post(url,{pidar:this.Items.pidar},this.headers());
                    if (!res.data.success) return;

                    let options={};
                    res.data.m.forEach(function (option) { options[option.pidfich]=option });

                    this.lignes.forEach(function (ligne) {
                        let option=options[ligne.pid];
                        ligne.retirable=ligne.retirableinit=!!(option && option.retirable);
                        ligne.doublable=ligne.doublableinit=!!(option && option.doublable);
                    });

                }catch (error) {
                    /* options indisponibles : la fiche reste utilisable, sans ingrédient modifiable */
                }

            },

            async loadfichetechnique(){

                this.$store.dispatch('lancerchargement',true)

                const t = this;
                let url=process.env.VUE_APP_API_URL+'/egl745874pstock771714dfe/fichetechnique/getall/'+this.Items.pidar+'/'+this.$store.state.appsociete+'/'+randomString();

                try {

                    let res=await axios.get(url,this.headers());

                    t.lignes=[];
                    t.supprimees=[];

                    if (res.data.success){

                        t.lignes=res.data.m.map(function (line) {
                            return {
                                pid:line.matiere.pid,
                                libelle:line.matiere.libelle,
                                unite:line.matiere.unite,
                                qte:parseFloat(line.qte),
                                qteinit:parseFloat(line.qte),
                                isnew:false,
                                retirable:false,
                                doublable:false,
                                retirableinit:false,
                                doublableinit:false,
                            }
                        });

                        await t.loadOptions();
                        await t.loadComposition();

                    }

                }catch (error) {
                    toastr['error']( "Une erreur est subvenue. <br/> veuillez contacter votre administrateur.","<b>Erreur</b>")
                }

                this.$store.dispatch('lancerchargement',false)

            },

        },

    }
</script>

<style scoped>
/* Charte cf-/ds- : tokens uniquement (light-only) */
.cf-overlay { position:fixed; inset:0; z-index:1000; display:flex; align-items:center; justify-content:center; padding:1rem; background:rgb(15 23 42 / 0.45); }
.cf-dialog { width:100%; background:#fff; border-radius:var(--cf-radius); box-shadow:var(--cf-shadow-md); display:flex; flex-direction:column; max-height:92vh; overflow:hidden; }
.cf-dialog--xl { max-width:1050px; }
.cf-dialog-head { display:flex; align-items:center; justify-content:space-between; padding:1rem 1.25rem; border-bottom:1px solid var(--cf-border); flex-shrink:0; }
.cf-dialog-title { margin:0; font-size:0.95rem; font-weight:700; color:var(--cf-ink-strong); }
.cf-dialog-close { height:2rem; width:2rem; flex-shrink:0; display:inline-flex; align-items:center; justify-content:center; border-radius:var(--cf-radius-sm); border:none; background:var(--cf-surface-alt); color:var(--cf-muted); cursor:pointer; transition:all .15s; }
.cf-dialog-close:hover { background:#fee2e2; color:rgb(var(--danger)); }
.cf-dialog-body { padding:1.1rem 1.25rem; overflow-y:auto; flex:1; }
.cf-dialog-foot { display:flex; align-items:center; justify-content:flex-end; gap:0.6rem; padding:0.9rem 1.25rem; border-top:1px solid var(--cf-border); background:var(--cf-surface); flex-shrink:0; }

/* Indicateurs */
.ft-kpis { display:grid; grid-template-columns:repeat(auto-fit,minmax(170px,1fr)); gap:0.75rem; margin-bottom:0.9rem; }
.ft-kpi { background:var(--cf-surface); border:1px solid var(--cf-border); border-radius:var(--cf-radius-sm); padding:0.7rem 0.9rem; }
.ft-kpi__label { display:block; font-size:0.72rem; color:var(--cf-muted); margin-bottom:2px; }
.ft-kpi__value { font-size:1.1rem; font-weight:700; color:var(--cf-ink-strong); }
.ft-kpi__value--ok { color:#15803d; }
.ft-kpi__value--warn { color:#a16207; }
.ft-kpi__value--ko { color:#b91c1c; }

.ft-note { font-size:0.78rem; color:var(--cf-muted); margin:0 0 0.6rem; }
.ft-sous { margin-top:3px; font-size:0.72rem; color:var(--cf-muted); line-height:1.35; }
.ft-note--warn { color:#a16207; background:#fef9c3; border-radius:var(--cf-radius-sm); padding:0.45rem 0.7rem; }

/* Table */
.table-scroll-wrap { overflow:auto; }
.ft-scroll { max-height:44vh; border:1px solid var(--cf-border); border-radius:var(--cf-radius-sm); }
.ft-table { width:100%; text-align:left; font-size:13px; border-collapse:collapse; min-width:680px; }
.th { position:sticky; top:0; z-index:2; padding:0.7rem 1rem; font-weight:600; font-size:0.75rem; color:var(--cf-ink); background:var(--cf-surface-alt); border-bottom:1px solid var(--cf-border); white-space:nowrap; letter-spacing:0.02em; text-align:left; }
.th--right { text-align:right; }
.th--center { text-align:center; }
.table-row { border-bottom:1px solid var(--cf-surface-alt); transition:background-color 0.15s; }
.table-row:hover { background:var(--cf-surface); }
.td { padding:0.5rem 1rem; font-size:0.82rem; color:var(--cf-ink); vertical-align:middle; white-space:nowrap; }
.td--right { text-align:right; }
.td--center { text-align:center; }
.cf-strong { font-weight:500; color:var(--cf-ink-strong); }
.ft-tag { margin-left:0.4rem; }
.ft-total { font-weight:700; color:var(--cf-ink-strong); background:var(--cf-surface); }
.ft-qte { width:100px; height:34px; padding:0 8px; text-align:right; border:1px solid rgb(var(--input-border,203 213 225)); border-radius:var(--cf-radius-sm); font-size:0.82rem; color:var(--cf-ink); outline:none; }
.ft-qte:focus { border-color:rgb(var(--primary)); box-shadow:0 0 0 3px rgb(var(--primary) / 0.10); }
.ft-qte--err { border-color:rgb(var(--danger)); }
.ft-del { height:2rem; width:2rem; display:inline-flex; align-items:center; justify-content:center; border-radius:var(--cf-radius-sm); border:none; background:var(--cf-surface-alt); color:var(--cf-muted); cursor:pointer; transition:all .15s; }
.ft-del:hover { background:#fee2e2; color:rgb(var(--danger)); }

/* Actions */
.ft-actions { display:flex; align-items:center; justify-content:space-between; gap:0.75rem; flex-wrap:wrap; margin:0.9rem 0 0.6rem; }
.ft-copy { display:flex; align-items:center; gap:0.5rem; }
.cf-inp { height:38px; min-width:240px; padding:0 12px; border-radius:var(--cf-radius-sm); border:1px solid rgb(var(--input-border,203 213 225)); background:#fff; color:var(--cf-ink); font-size:0.82rem; outline:none; }
.cf-select { cursor:pointer; }
.ft-foot-info { margin-right:auto; font-size:0.78rem; color:#a16207; }

/* Empty state */
.empty-state { padding:2rem 1.5rem; text-align:center; }
.empty-state__icon { font-size:36px; color:var(--cf-faint); margin-bottom:10px; }
.empty-state__title { font-size:0.92rem; font-weight:600; color:var(--cf-ink-strong); margin:0; }
.empty-state__sub { font-size:0.8rem; color:var(--cf-muted); margin:4px 0 0; }

.modal-fade-enter-active, .modal-fade-leave-active { transition:opacity 0.25s ease; }
.modal-fade-enter-from, .modal-fade-leave-to { opacity:0; }
.modal-slide-enter-active, .modal-slide-leave-active { transition:all 0.25s ease; }
.modal-slide-enter-from, .modal-slide-leave-to { opacity:0; transform:translateY(-16px); }

@media (max-width:768px) { .cf-dialog--xl { max-width:100%; } .ft-copy { width:100%; } .cf-inp { min-width:0; flex:1; } }
.ft-check { width:17px; height:17px; accent-color:rgb(var(--primary)); cursor:pointer; }
</style>
